import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Resume from '@/components/Resume.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', 
    name: 'home',
    component: Resume,
  },
  { path: '/resume', 
    name: 'resume',
    component: Resume,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
